import { Settings, X } from 'lucide-react'

export default function CanalesSRBadge({ result, onOpenSettings, onClose, version = '1.0' }) {
  const dash = result?.dashboard ?? {}

  const signalColor = dash.signal === 'Buy'
    ? 'text-emerald-400'
    : dash.signal === 'Sell'
    ? 'text-red-400'
    : 'text-slate-400'

  const trendColor = dash.trend === 'Bullish'
    ? 'text-emerald-400'
    : dash.trend === 'Bearish'
    ? 'text-red-400'
    : 'text-slate-400'

  const strengthColor = dash.strength === 'Strong'
    ? 'text-emerald-400'
    : dash.strength === 'Medium'
    ? 'text-yellow-400'
    : dash.strength === 'Weak'
    ? 'text-orange-400'
    : 'text-slate-400'

  return (
    <div className="absolute top-2 left-2 z-10 flex flex-col gap-1 rounded-lg bg-gray-900/85 dark:bg-black/85 backdrop-blur-sm border border-gray-700/50 shadow-lg overflow-hidden min-w-[170px]">
      <div className="flex items-center gap-1.5 px-2.5 pt-2 pb-1">
        <span className="text-[11px] font-bold text-white tracking-tight">
          Canales S/R <span className="text-gray-400 font-normal">[{version}]</span>
        </span>
        <button onClick={onOpenSettings} title="Configuración" className="ml-auto p-0.5 text-gray-400 hover:text-white transition-colors rounded hover:bg-gray-700/50">
          <Settings size={12} />
        </button>
        <button onClick={onClose} title="Desactivar" className="p-0.5 text-gray-400 hover:text-red-400 transition-colors rounded hover:bg-gray-700/50">
          <X size={12} />
        </button>
      </div>

      <div className="flex flex-col gap-0.5 px-2.5 pb-2">
        <Row label="Tendencia">
          <span className={trendColor}>{dash.trend}</span>
        </Row>
        <Row label="Señal">
          <span className={signalColor}>{dash.signal}</span>
        </Row>
        <Row label="Fuerza">
          <span className={strengthColor}>{dash.strength}</span>
        </Row>
        <Row label="Calidad">
          <span className="text-slate-300">{dash.quality}</span>
        </Row>
        <Row label="Canales">
          <span className="text-slate-300">{dash.activeChannels}</span>
        </Row>
      </div>
    </div>
  )
}

function Row({ label, children }) {
  return (
    <div className="flex items-center justify-between gap-4">
      <span className="text-[10px] text-gray-500">{label}</span>
      <span className="text-[10px]">{children}</span>
    </div>
  )
}
